import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13 19.5a1.5 1.5 0 1 0 2.095-1.377l-1.252-3.756a2.995 2.995 0 0 0 1.04-3.198l3.288-2.348a2 2 0 0 0 1.231.139A2 2 0 0 0 21 7a2 2 0 1 0-3.99.193l-3.29 2.35A3 3 0 0 0 12 9a3 3 0 0 0-1.293.292l-1.88-1.878a2.49 2.49 0 0 0-.44-2.553 2.49 2.49 0 0 0-2.481-.79A2.504 2.504 0 0 0 4 6.5c0 .753.333 1.429.86 1.887A2.5 2.5 0 0 0 6.5 9c.322 0 .63-.061.914-.172l1.878 1.879A3 3 0 0 0 11.945 15l1.253 3.755c-.126.22-.198.474-.198.745m4.543-1.731A7.98 7.98 0 0 0 20 12q0-.564-.076-1.107a4 4 0 0 0 1.851-1.012c.147.683.225 1.392.225 2.119a9.99 9.99 0 0 1-4.04 8.03 3.5 3.5 0 0 0-.417-2.261M12.05 22a3.5 3.5 0 0 1-1.022-2.058A8 8 0 0 1 4.17 10.35a4.5 4.5 0 0 1-1.606-1.669A10 10 0 0 0 2 12c0 5.523 4.477 10 10 10z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M8.682 2.564A10 10 0 0 1 12 2c1.893 0 3.664.526 5.173 1.44a4 4 0 0 0-1.555 1.423 8.03 8.03 0 0 0-5.267-.693 4.5 4.5 0 0 0-1.669-1.606"
    }
  )
);
var SvgIntegrations1Outlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Integrations1Outlined_default = SvgIntegrations1Outlined;

export { Integrations1Outlined_default as default };
